import { get } from "lodash";

export const getDocumentTypeHN = value => {
    switch (value) {
      case 'CC':
        return 'NI';
      case 'PA':
        return 'PASS';
      case 'CR':
        return 'RES';
      default:
        return 'NI'
    }
  }

  export const getProductPriceHN = (pkg, currency = 'USD') => {
    const { pricesList = [] } = pkg
    const currencyObj = pricesList.find(listItem => listItem.price.currency === currency);
    if (currencyObj) {
      const { price: { taxIncludedAmount, taxes } } = currencyObj;
      return { taxIncludedAmount, taxes, priceWithoutTax: (Number(taxIncludedAmount) - Number(taxes)).toFixed(2) }
    }
    return { taxIncludedAmount: '0.00', taxes: '0.00', priceWithoutTax: '0.00' }
  }

  export const getAddonDetailsHN = pkg => {
    const entries = get(pkg, 'commercialEnrichmentsList[0].descriptions.entries', [])
    if (entries.length) {
      const { value: description } = entries.find(entry => entry.key === 'short-description') || {};
      const { value: name } = entries.find(entry => entry.key === 'familyName') || {};
      const { value: type } = entries.find(entry => entry.key === 'serviceType') || {};
      return { description, name, type }
    }
    return { name: '', description: '', type: '' }
  }

  export const filterPackagesHN = (packages, type) => {
    switch (type.toUpperCase()) {
      case 'PAQUETE':
        return packages.filter(pkg => pkg.type === 'Bundle')
      case 'TV':
        return packages.filter(pkg => pkg.type === 'Single TV')
      case 'INTERNET':
        return packages.filter(pkg => pkg.type === 'Single Internet')
      default:
        return packages
    }
  }